import React, {Component} from 'react';
import * as unauthorised from "../../assets/403-forbidden.jpg";

class AccessRestricted extends Component {
    render() {
        return (<div>
            <a href="/dashboard" style={{textDecoration:'none'}}> <img src={unauthorised} style={{position:'absolute',top:'0',left:'0',width:'100%',maxHeight:'100%',border:'0',zIndex:'-999'}} alt="403 You do not have enough permission to view this page" /></a>
        </div>);
    }
}

export default AccessRestricted;


// WEBPACK FOOTER //
// ./src/views/universal/access_restricted.js